import { useTranslation } from "react-i18next";

import * as BeAPI from "../../../../API";
import PageView from "../../../../Components/PageView";
import { useEffect, useState } from "react";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface OutletProps {
  id?: string;
  name: string;
  location: string;
}

const Outlets = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<OutletProps[]>([]);

  const getData = () => {
    BeAPI.getAll("outlets")
      .then((res: OutletProps[]) =>
        setData(
          res.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1
          )
        )
      )
      .catch((err) => console.log({ err }));
  };

  useEffect(() => {
    getData();
  }, []);

  const formInputs = [
    {
      name: "name",
      label: t("Services.Outlets.Outlet"),
      type: "text",
      required: true,
    },
    {
      name: "location",
      label: t("Services.Outlets.Location"),
      type: "url",
      required: true,
      render: (row: OutletProps) => (
        <a className="text-primary" href={row.location} target="_blank">
          <FontAwesomeIcon icon={faEye} />
        </a>
      ),
    },
  ];

  const onSubmit = (values: OutletProps) => {
    BeAPI.create("outlets", values)
      .then(() => {
        getData();
      })
      .catch((err) => console.log({ err }));
  };

  const onDelete = (id: string) =>
    BeAPI.remove("outlets", id)
      .then(() => {
        getData();
      })
      .catch((err) => console.log({ err }));

  return (
    <PageView
      title={t("Services.Outlets.OutletsList")}
      data={data}
      inputs={formInputs}
      onSubmit={onSubmit}
      onDelete={onDelete}
    />
  );
};

export default Outlets;
